var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActOpenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23747 5.13159L13.3077 1.43347C13.542 1.26269 13.666 1.09061 13.666 0.947579C13.666 0.671055 13.2216 0.5 12.4776 0.5L1.51937 0.5C0.776275 0.5 0.332683 0.67084 0.332683 0.946716C0.332683 1.08996 0.456802 1.25929 0.691766 1.43046L5.76188 5.1303C6.08848 5.36823 6.52797 5.5 6.99994 5.5C7.4716 5.50005 7.91098 5.3698 8.23747 5.13159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActOpenWhite);
export default __webpack_public_path__ + "static/media/act_open_white.e089cc68050bc6f8d78681135835fa15.svg";
export { ForwardRef as ReactComponent };